/* Become a Dealer — single-page application form
   Submits to the same Cloudflare Worker as Equip Your Door, with
   form_type=become-a-dealer to discriminate. */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var root = document.querySelector('[data-dealer-root]');
    if (!root) return;
    var form = root.querySelector('[data-dealer-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) return;

      var workerUrl = form.getAttribute('data-eyd-worker-url') || '';
      if (!workerUrl) {
        flashError(form, 'The form is not configured to submit yet. Please contact us directly.');
        return;
      }

      var submitBtn = e.submitter || form.querySelector('[data-dealer-submit]');
      var originalLabel = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.classList.add('eyd-btn--loading');
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Sending';
      }

      // Build FormData straight from the form — no path branching needed
      var fd = new FormData(form);

      fetch(workerUrl, { method: 'POST', body: fd })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
        .then(function (r) {
          if (!r.ok || !r.body || !r.body.ok) {
            throw new Error((r.body && r.body.error) || 'Submission failed');
          }
          var caseEl = root.querySelector('[data-dealer-case-ref]');
          if (caseEl) caseEl.textContent = r.body.caseRef || '';
          // hide form panel, show success
          root.querySelectorAll('.eyd-step-panel').forEach(function (p) { p.classList.remove('is-active'); });
          var success = root.querySelector('[data-step-panel="success"]');
          if (success) success.classList.add('is-active');
          try { success.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
        })
        .catch(function (err) {
          console.error('[Dealer] submit failed:', err);
          if (submitBtn) {
            submitBtn.classList.remove('eyd-btn--loading');
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalLabel;
          }
          flashError(form, "We couldn't send your application. Please try again, or contact us directly if the issue continues.");
        });
    });
  }

  function validate(form) {
    var ok = true;
    ['company', 'city', 'state', 'name', 'email'].forEach(function (n) {
      var el = form.querySelector('[name="' + n + '"]');
      if (el && !el.value.trim()) { el.style.borderColor = 'var(--eyd-accent)'; ok = false; }
      else if (el) { el.style.borderColor = ''; }
    });
    var emailEl = form.querySelector('[name="email"]');
    if (emailEl && emailEl.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value)) {
      emailEl.style.borderColor = 'var(--eyd-accent)';
      ok = false;
    }
    if (!ok) flashError(form, 'Fill in the required fields above.');
    return ok;
  }

  function flashError(form, msg) {
    var existing = form.querySelector('.eyd-flash');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'eyd-flash';
    div.style.cssText = 'background:var(--eyd-accent-soft);color:var(--eyd-accent);padding:12px 16px;border:1px solid var(--eyd-accent);font-size:14px;margin-bottom:16px;';
    div.textContent = msg;
    var actions = form.querySelector('.eyd-actions');
    if (actions) actions.before(div);
    setTimeout(function () { div.remove(); }, 4000);
  }
})();
